module.exports = __webpack_public_path__ + "media/img/vca/bg-about-2022-a6bb048a057377795e714100f9e4156f.png";